import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ContextItem, RequirementStatusViewProps } from "../../../../types";
import { toWSDateString, WSPillProps } from "@wingspanhq/fe-component-library";
import { RequirementStatus } from "@wingspanhq/payments/dist/interfaces/requirement";
import { ISignedDocumentResponse } from "@wingspanhq/signed-documents/dist/lib/interfaces";
import { selectorIsRequirementReadyToSignAsPayer } from "../../../../selectors/selectorIsRequirementReadyToSignAsPayer";

export const getSignaturePayerRequirementStatus = (
  requirement: IRequirementResponse,
  contextItem: ContextItem,
  signedDocument: ISignedDocumentResponse | undefined
): RequirementStatusViewProps => {
  let pill: WSPillProps;

  let secondaryText: string | undefined;

  const isRequirementReadyToSignAsPayer =
    selectorIsRequirementReadyToSignAsPayer(requirement, signedDocument);

  if (requirement.status === RequirementStatus.Complete) {
    pill = {
      theme: "success",
      text: "Complete",
      icon: true
    };

    secondaryText =
      signedDocument?.events?.payeeSignedAt || signedDocument?.updatedAt
        ? toWSDateString(
            signedDocument?.events?.payeeSignedAt || signedDocument?.updatedAt,
            "monthDayYear"
          )
        : "";
  } else if (isRequirementReadyToSignAsPayer) {
    pill = {
      theme: "warning",
      text: "Action required",
      icon: true
    };
    secondaryText = "Awaiting your signature";
  } else {
    pill = {
      theme: "neutral",
      text: "Awaiting contractor",
      icon: "time"
    };
    secondaryText = "Awaiting contractor signature";
  }

  return {
    pill,
    secondaryText
  };
};
